import { Component } from '@angular/core';
import { TitleCardModel } from '../../../../models/title-card.model';

@Component({
  selector: 'app-philosophy',
  templateUrl: './philosophy.component.html',
  styleUrl: './philosophy.component.scss',
  standalone: false,
})
export class PhilosophyComponent {
  public titleCard: TitleCardModel = {
    image: '../../../assets/images/placeholder.svg',
  };

  public register() {
    throw new Error('Not implemented');
  }
}
